
/**
 * Description: 转义字符处理
 * @param {string} text
 * @returns {string}
 */
export function htmlEscape(text){
  return text.replace(/["]/g, function(match, pos, originalText){
    switch(match){
      // case "<": return "&lt;";
      // case ">":return "&gt;";
      // case "&":return "&amp;";
      case "\"":return "&quot;";
    }
  });
}

/**
 * Description: %字符处理
 * @param {string} text
 * @returns {string}
 */
export function encodeSearchKey(text){
  return text.replace(/[%]/g, function(match, pos, originalText){
    switch(match){
      // case "<": return "&lt;";
      // case ">":return "&gt;";
      // case "&":return "&amp;";
      case "%":return "%25";
    }
  });
}

//获取指定form中的所有的<input>对象
function getElements(formName) {
  var form = document.getElementsByName(formName);
  console.log("request form:", form)
  var elements = new Array();
  var tagElements = form.getElementsByTagName('input');
  for (var j = 0; j < tagElements.length; j++){
    elements.push(tagElements[j]);

  }
  return elements;
}

//获取单个input中的【name,value】数组
function inputSelector(element) {
  if (element.checked)
    return [element.name, element.value];
}

function input(element) {
  switch (element.type.toLowerCase()) {
    case 'submit':
    case 'hidden':
    case 'password':
    case 'text':
      return [element.name, element.value];
    case 'checkbox':
    case 'radio':
      return inputSelector(element);
  }
  return false;
}

//组合URL
function serializeElement(element) {
  var parameter = input(element);
  if (parameter) {
    var key = encodeURIComponent(parameter[0]);
    if (key.length == 0) return;

    if (parameter[1].constructor != Array)
      parameter[1] = [parameter[1]];

    var values = parameter[1];
    var results = [];
    for (var i=0; i<values.length; i++) {
      results.push(key + '=' + encodeURIComponent(values[i]));
    }
    return results.join('&');
  }
}

//调用方法
export function serializeForm(formId) {
  var elements = getElements(formId);
  var queryComponents = new Array();

  for (var i = 0; i < elements.length; i++) {
    var queryComponent = serializeElement(elements[i]);
    if (queryComponent)
      queryComponents.push(queryComponent);
  }

  return queryComponents.join('&');
}






// WEBPACK FOOTER //
// ./src/utils/opxpUtil.js